import React, { Component } from "react";
import styles from "./styles.module.css";

export default class MobilePage extends Component {
  render = () =>
    <div className={styles.container}>
      <div className={styles.pageLogo}>
        <img src={require('./images/CTG-Ride_logo_dark.svg')} />
      </div>
      <div className={styles.pageTitle}>
        For full functionality please use our apps:
      </div>
      <div className={styles.appBlock}>
        <div className={styles.appBlockItem}>
          <a href='https://apps.apple.com/us/app/id1505323247'>
            <img src={require('./images/app_store_badge.png')}
                 srcSet={`
                    ${require('./images/app_store_badge@2x.png')} 2x,
                    ${require('./images/app_store_badge@3x.png')} 3x,
                 `}
            />
          </a>
        </div>
        <div className={styles.appBlockItem}>
          <a href='https://play.google.com/store/apps/details?id=com.ctg.ride&hl=en&utm_source=CTGRide%20website'>
            <img src={require('./images/google-play-badge.jpg')}
                 srcSet={`
                    ${require('./images/google-play-badge@2x.jpg')} 2x,
                    ${require('./images/google-play-badge@3x.jpg')} 3x,
                 `}
            />
          </a>
        </div>
      </div>
    </div>;
}
